import type { TUnidadeTipoEnum } from '@/shared/interfaces/produto.enums'
import type { TGetProdutosResponse } from '@/shared/interfaces/produto.types'
import { HttpService } from '@/shared/lib/http'

export class GetProdutosService extends HttpService {
  execute = async (idExternoBloco: number, tipoDoProduto: TUnidadeTipoEnum, isVagaPadrao = false) => {
    return this.http.get<TGetProdutosResponse>(
      `/api/v2/Produto/bloco/${idExternoBloco}/tipoProduto/${tipoDoProduto}?vagasPadrao=${isVagaPadrao}`,
    )
  }
}
